/*
Description: This is the file that will handle interacting with the JaneApp EMR
Date: 11/29/2023
Author: Jacob Michalski


Notes:
    All Injectors need the following functions:
        getQuestions
        answerQuestions (Consider combining these and making the single a private function)
        answerQuestion


MW/Empower Specifics:
    The Note Card is document.querySelectorAll(".mwCard")[1]
    There are multiple Choice Questions
    Use the helper functions to get the questions and answer them

    There are Long Answer questions
    Sometimes the MC questions are actually triggers for the Long Answer questions

    # Sounds like there is always an extended response question at the end
    For now let's do Scrape all the question and then answer them in Long Answer in that last text box

    # Iterate over all sections to grab this information and answer all the questions




*/

/** Public Functions */

export function getPageInfo() {
  // function getPageInfo() {
  /*
    Description: This function will get the page info from the note
    Return: A dictionary with the page info
        {
            "URL": Base URL for the page,
            "Note Type": "PT Daily/SOAP Note",...
        }
    */
  const baseURL = window.location.origin;
  const noteTitleElement = document.querySelector('[id=ctl00_cp1_notetitle]');
  if (!noteTitleElement) {
    return {
      URL: baseURL,
      'Note Type': null
    };
  }

  const noteType = noteTitleElement.textContent.split(' for')[0];
  return {
    URL: baseURL,
    'Note Type': noteType || null
  };
}

export function getPatientInfo() {
  // function getPatientInfo() {
  /*
    Description: This function will get the patient info from the note
    Return: A dictionary with the patient info
    {
        "EMR ID": 0x1234 or "michalskij"
        "First Name":firstName,
        "Last Name": lastName,
        "DOB": dob,
    }
    */
  // name=ctl00_cp1_patientFirst
  // use the query selector to get the patient info
  const firstNameElement = document.querySelector(
    '[id=ctl00_cp1_patientFirst]'
  );
  const lastNameElement = document.querySelector('[id=ctl00_cp1_patientLast]');
  const dobElement = document.querySelector('[id=ctl00_cp1_patientDOB]');
  const emrIDElement = document.querySelector('[id=ctl00_cp1_Episode1_pid]');

  const firstName = firstNameElement ? firstNameElement.value : '';
  const lastName = lastNameElement ? lastNameElement.value : '';
  const dob = dobElement ? dobElement.value : '';
  const emrID = emrIDElement ? emrIDElement.value : '';

  return {
    'EMR ID': emrID,
    'First Name': firstName,
    'Last Name': lastName,
    DOB: dob
  };
}

/** Helper Functions */
function getNote() {
  let notes = [];

  // Select both elements if they exist
  let gridView = document.querySelector('#ctl00_cp1_TheItems_GridView1');
  let lastMatrix = document.querySelector('#ctl00_cp1_Lastmatrix1_vPanel');

  if (gridView) notes.push(gridView);
  if (lastMatrix) notes.push(lastMatrix);

  return notes.length > 0 ? notes : null; // Return array if found, otherwise null
}

function getMCChoices(selector) {
  var mcChoices = selector.querySelectorAll('option');
  var mcChoicesArray = Array.from(mcChoices);
  var mcChoicesText = mcChoicesArray.map((choice) => {
    return choice.textContent;
  });
  return mcChoicesText;
}

function getChooseAllChoices(checkboxes) {
  let choices = {};
  for (var i = 0; i < checkboxes.length; i++) {
    let choiceText = checkboxes[i].parentElement.textContent;
    let choiceElement = checkboxes[i];
    choices[choiceText] = (trueOrFalse) => {
      if (trueOrFalse) {
        // Click it
        if (!choiceElement.checked) {
          choiceElement.click();
        }
      } else {
        // Un-click it
        if (choiceElement.checked) {
          choiceElement.click();
        }
      }
    };
  }
  return choices;
}

function answerMC(selector, choice) {
  // Verify the choice is valid
  var mcChoices = getMCChoices(selector);
  if (!mcChoices.includes(choice)) {
    console.error('Invalid Choice');
    return false;
  }
  // Find the option with the selected attribute and Remove the selected attribute from the selected option
  var selectedOption = selector.querySelector('option[selected="selected"]');
  selectedOption.removeAttribute('selected');

  // Apply the selected attribute to the selected option
  mcChoices = selector.querySelectorAll('option');
  for (var i = 0; i < mcChoices.length; i++) {
    if (mcChoices[i].textContent === choice) {
      mcChoices[i].setAttribute('selected', 'selected');
    }
  }
  // Trigger the change event on the select element
  selector.dispatchEvent(new Event('change'));
  return true;
}

function scrapeQuestions(note, empowerNewVersion = false) {
  /*
    Given the entire Note, return a dictionary {
        "Question Text?": {
            "Type": 

            if Long Answer or Long Answer
            "Input": func(val) -> Drops into the text Box
            if MC or Choose All
            "Choices":{
                "choice1": func() -> Selects this option,
                ...
            }

        }
    }
    */

  var qBulk = note?.parentElement;

  // for each of the children of the bulk, we want to get the text and add it to the question
  var questions = {};
  if (qBulk && qBulk.children && qBulk.children.length > 0) {
    for (var i = 0; i < qBulk.children.length; i++) {
      var child = qBulk.children[i];
      if (child.querySelector('tbody')) {
        var tables = child.querySelectorAll('tbody');

        for (var table of tables) {
          try {
            var tableQuestions = scrapeTable(table, empowerNewVersion);
          } catch (e) {
            console.error(
              'Error scraping table - Likely a nested table like choose all'
            );
            console.error(e);
            getLogFromInjector();
            continue;
          }

          for (let tableName in tableQuestions) {
            var tableQuestionsList = tableQuestions[tableName];
            if (!questions[tableName]) {
              questions[tableName] = {
                Question: tableName,
                Key: tableName,
                originalElement: table,
                Type: 'Flex',
                Structure: {}
              };
            }

            for (var j = 0; j < tableQuestionsList.length; j++) {
              var q = tableQuestionsList[j];
              var choices = filterChoices(q['Choices']);
              const hasRealChoices = choices.length > 0;
              choices.push('None');
              var choicesText = Array.isArray(choices)
                ? choices.join(', ')
                : Object.keys(choices).join(', ');
              let qKey = q['QuestionTextArray'].join(' - ');
              qKey = `${qKey} - ${q['Question']}`;
              let existingData = q['ExistingNote'] || '';
              let pattern = detectPatternIfNeeded(choices);

              let qText = qKey;
              if (hasRealChoices) {
                if (qText.toLowerCase().includes('date')) {
                  qText = qKey;
                } else {
                  qText =
                    qKey +
                    ` When answering, consider all provided choices carefully (Choices: ${pattern ? pattern : choicesText}). Ensure responses contain all the information mentioned and specific`;
                }
              }
              let mainCategory = q['QuestionTextArray'][0];
              let subCategory = q['QuestionTextArray'][1];

              if (
                !questions[tableName]['Structure'][mainCategory || tableName]
              ) {
                questions[tableName]['Structure'][mainCategory || tableName] =
                  {};
              }
              questions[tableName]['Structure'][mainCategory || tableName][
                subCategory || mainCategory || tableName
              ] = {
                Description: qText,
                Input: q['Input'],
                'Existing Value': existingData
              };
            }
          }
        }
      }
    }
  }

  // ?? document: TS defaults don't apply to null, only undefined — passing null crashes scope.querySelectorAll
  // e.g. SOAP sections disappear when empowerNewVersion=false because they rely on processTextAreas
  processTextAreas(questions, false, qBulk ?? document);
  return questions;
}

function filterChoices(choices) {
  try {
    if (Array.isArray(choices)) {
      return choices.filter(
        (value) =>
          value != 'Quick Text' &&
          value != 'Clear the text' &&
          value != '+ via EMR or Pencil' &&
          value != 'Not Tested'
      );
    } else {
      return Object.keys(choices)
        .filter(
          (value) =>
            value != 'Quick Text' &&
            value != 'Clear the text' &&
            value != '+ via EMR or Pencil' &&
            value != 'Not Tested'
        )
        .reduce((acc, key) => {
          acc[key] = choices[key];
          return acc;
        }, {});
    }
  } catch (e) {
    console.error(e);
    console.error(choices);
    getLogFromInjector();
    return choices;
  }
}

function detectPatternIfNeeded(choices) {
  if (choices && Array.isArray(choices) && choices.length > 20) {
    let pattern = detectPattern(choices);
    if (pattern) {
      choices = [];
      return pattern;
    }
  }
  return null;
}

function processTextAreas(
  questions,
  skipTextAreaSearch = false,
  scope: ParentNode = document
) {
  if (!skipTextAreaSearch) {
    var answerInputBoxes = scope.querySelectorAll('textarea');
    console.log('Total textareas found:', answerInputBoxes.length);

    answerInputBoxes.forEach((inputBox, index) => {
      if ((inputBox as HTMLElement).dataset.comprehendGrouped === 'true')
        return;
      let parentRow = inputBox.closest('tr');
      let sectionHeaderRow = findSectionHeaderRow(parentRow);
      let sectionLabel = sectionHeaderRow
        ? sectionHeaderRow.querySelector('td[colspan]')?.textContent.trim()
        : '';
      // Some rows have an empty/icon-only first td (e.g. trash button); scan all tds for the first with text
      let planLabelText: string | null = null;
      if (parentRow) {
        const tds = parentRow.querySelectorAll('td');
        for (const td of tds) {
          const text = td.textContent.trim();
          if (text) {
            planLabelText = text;
            break;
          }
        }
      }
      if (!planLabelText) return;

      // Goal textareas are already captured as Flex subfields; skip re-registering them as Long Answer
      if (sectionLabel && questions[sectionLabel]?.Type === 'Flex') return;

      let qText2 = cleanLabelText(planLabelText);
      let existingNote = getExistingNote(inputBox.value);
      let replyType =
        Object.keys(questions).length === 0 ? 'overwrite' : 'no_reply';

      questions[sectionLabel + ' - ' + qText2] = {
        Key: sectionLabel + ' - ' + qText2,
        Type: 'Long Answer',
        originalElement: inputBox,
        ExistingNote: existingNote,
        Input: (val, replyType) => {
          if (isEmptyOrNull(val)) {
            return;
          }
          if (replyType === 'append') {
            inputBox.value = (inputBox.value + '\n' + val).trim();
          } else {
            inputBox.value = val;
          }
        },
        ReplyType: replyType
      };
    });
  }

  // Always get the last text area
  var answerInputBox = document.querySelector('textarea#ctl00_cp1_text');
  var planElement = document.querySelector('#ctl00_cp1_sectionnm');
  var qText2 = cleanLabelText(
    planElement?.textContent.trim() +
      ' ' +
      planElement?.parentNode.querySelector('strong')?.textContent.trim()
  );

  let replyType =
    Object.keys(questions).length === 0 ? 'overwrite' : 'no_reply';
  let existingNote = getExistingNote(answerInputBox.value);
  questions[qText2] = {
    Key: qText2,
    Type: 'Long Answer',
    originalElement: answerInputBox,
    ExistingNote: existingNote,
    Input: (val, replyType) => {
      if (isEmptyOrNull(val)) {
        return;
      }
      if (replyType == 'append') {
        answerInputBox.value = (answerInputBox.value + '\n' + val).trim();
      } else {
        answerInputBox.value = val;
      }
    },
    ReplyType: replyType
  };
}

function findSectionHeaderRow(parentRow) {
  let sectionHeaderRow = parentRow;
  while (sectionHeaderRow) {
    const colspanTd = sectionHeaderRow.querySelector('td[colspan]');
    if (colspanTd) {
      const hasInputs = colspanTd.querySelector('input, textarea, select');
      const text = colspanTd.textContent.trim();
      if (!hasInputs && text) break;
    }
    sectionHeaderRow = sectionHeaderRow.previousElementSibling;
  }
  return sectionHeaderRow;
}

function cleanLabelText(labelText) {
  let cleanedText = labelText.replace(/[\s\n]+/g, ' ').trim();
  if (cleanedText.endsWith(':')) {
    cleanedText = cleanedText.slice(0, -1).trim();
  }
  return cleanedText;
}

function scrapeTable(table, empowerNewVersion = false) {
  /*
    Given a table, scrape the text from it
 
    Return: {
        "Table Title":
        [{
            "Question": "Injury Date",
            "Choices": ["Today", "Yesterday", "Other"]
            "Input": writeToInputBox(str)
        },...],
        "Table 2": [{}...],...
    }
    */

  // var rows = table.querySelectorAll("tr")
  // console.log(table)
  // Get the actual table
  // let table2 = table.querySelector('tbody');
  // if (table2) {
  //   table = table2;
  //   console.log('Got the table2');
  //   console.log(table2);
  // }
  var rows = table.querySelectorAll(':scope > tr');

  let tableTitle = null;
  let toReturn = {};
  // For flat mode (empowerNewVersion=false): accumulate per-section textareas and emit
  // one combined question per section after the row loop instead of individual subfields.
  const flatSections: { [title: string]: HTMLTextAreaElement[] } = {};
  let columnHeaders = [];

  for (var j = 0; j < rows.length; j++) {
    console.log(rows[j]);
    var row = rows[j];

    let tds = row.querySelectorAll('td');
    let questionText = '';
    let i = 0;

    // Iterating over them is necessary if there is a delete trash can in the first column but the content is in the next column
    while (questionText === '' && i < 3) {
      let questionTextElement = tds[i];
      if (questionTextElement) {
        questionText = questionTextElement.textContent.trim();
      }
      i++;
    }

    if (questionText === '') {
      console.log(`Skipping row ${row.textContent}`);
      continue;
    }

    var optionSelector = row.querySelector('select');
    var textareaSelector = row.querySelector('textarea');
    // Multi-column matrix rows (e.g. Goals at box height > 1) must stay in the column branch
    var isMultiColumnDataRow =
      optionSelector && row.querySelectorAll('textarea').length > 1;
    if ((!optionSelector || textareaSelector) && !isMultiColumnDataRow) {
      // Handle Choose All Questions
      var chooseAllChoices = row.querySelectorAll(
        "table td > input[type='checkbox']"
      );
      if (chooseAllChoices.length === 0) {
        // If not a choose all, it's a row head
        // It is actually only a row head if there is only 1 column
        if (row.querySelectorAll('td').length > 1) {
          // Check if this is a label + textarea row (single-column input pattern, e.g. SOAP)
          // If so, group it into the Flex structure instead of treating as a column header
          let rowTextarea = row.querySelector('textarea');
          if (rowTextarea && tableTitle) {
            (rowTextarea as HTMLElement).dataset.comprehendGrouped = 'true';
            let existingNote = rowTextarea.value
              ? rowTextarea.value.trim()
              : '';
            let textarea = rowTextarea;
            if (empowerNewVersion) {
              // Enabled: SOAP appears as one expandable section whose
              // dropdown contains Subjective, Objective, Treatment, Assessment, Plan.
              toReturn[tableTitle] = toReturn[tableTitle] || [];
              toReturn[tableTitle].push({
                QuestionTextArray: [tableTitle, questionText],
                Question: questionText,
                Choices: [],
                ExistingNote: existingNote,
                Input: (val, replyType) => {
                  if (!val || val === '' || val === 'None') return;
                  if (replyType === 'append') {
                    textarea.value = (textarea.value + '\n' + val).trim();
                  } else {
                    textarea.value = val;
                  }
                }
              });
            } else {
              // Disabled (default): each subfield becomes its own top-level panel
              // section, keyed as "SOAP - Subjective", "SOAP - Objective" etc.
              const sectionKey = `${tableTitle} - ${questionText}`;
              if (!flatSections[sectionKey]) flatSections[sectionKey] = [];
              flatSections[sectionKey].push(rowTextarea as HTMLTextAreaElement);
            }
            continue;
          }

          // Multi-TD rows with a text-only td[colspan] are section headers (e.g. header + "Add" button).
          const colspanTd = row.querySelector('td[colspan]');
          if (
            colspanTd &&
            !colspanTd.querySelector('input, textarea, select')
          ) {
            const colspanText = colspanTd.textContent.trim();
            if (colspanText) {
              tableTitle = colspanText;
              if (!(toReturn as any)[tableTitle])
                (toReturn as any)[tableTitle] = [];
              continue;
            }
          }

          console.log(`Skipping row ${row.textContent}`);
          // iterate on all the td elements and get the text content
          for (let td of row.querySelectorAll('td')) {
            if (td.textContent.trim() !== '') {
              columnHeaders.push(td.textContent.trim());
            }
          }
          continue;
        }

        console.log(`Got Row header... ${questionText}`);
        tableTitle = rows[j].textContent.trim();
        toReturn[tableTitle] = [];
      } else {
        // If it is a choose all, we want to add a question for each choice
        // let options = getChooseAllChoices(chooseAllChoices);
        // console.log(`Got Choose All... ${questionText}`);
        // console.log(options);
        // toReturn[tableTitle].push({
        //   Question: questionText,
        //   Choices: options,
        //   Type: 'Choose All',
        //   Input: (val, replyType) => {

        //   }
        // });
        let checkboxes = chooseAllChoices;

        if (checkboxes.length > 0) {
          let options = Array.from(checkboxes)
            .map((checkbox) => checkbox.nextElementSibling?.textContent?.trim())
            .filter((label) => label && /[a-zA-Z0-9]/.test(label)); // Exclude empty strings and icon-only Unicode characters

          if (!tableTitle) {
            console.error('No table title found for checkboxes, skipping');
            continue;
          }

          toReturn[tableTitle] = toReturn[tableTitle] || [];

          if (options.length === 0) {
            // Hold-only row: capture the goal textarea directly into the Flex structure.
            let rowTextareas = Array.from(
              row.querySelectorAll('textarea')
            ) as HTMLTextAreaElement[];
            if (rowTextareas.length === 0 && row.nextElementSibling) {
              rowTextareas = Array.from(
                row.nextElementSibling.querySelectorAll('textarea')
              ) as HTMLTextAreaElement[];
            }
            let rowTextarea = rowTextareas[rowTextareas.length - 1] || null;
            if (rowTextarea) {
              let existingNote = rowTextarea.value
                ? rowTextarea.value.trim()
                : '';
              let textarea = rowTextarea;
              rowTextareas.forEach(
                (ta) => ((ta as HTMLElement).dataset.comprehendGrouped = 'true')
              );
              toReturn[tableTitle].push({
                QuestionTextArray: [tableTitle, questionText],
                Question: questionText,
                Choices: [],
                ExistingNote: existingNote,
                Input: (val, replyType) => {
                  if (!val || val === '' || val === 'None') return;
                  if (replyType === 'append') {
                    textarea.value = (textarea.value + '\n' + val).trim();
                  } else {
                    textarea.value = val;
                  }
                }
              });
            }
            continue;
          }

          // Disabled: each checkbox group gets its own "<section> - <label>" card
          const soTitle = empowerNewVersion
            ? tableTitle
            : `${tableTitle} - ${questionText}`;
          (toReturn as any)[soTitle] = (toReturn as any)[soTitle] || [];

          // Group's notes box: same row, else the next row (Empower renders both layouts)
          let notesBox = row.querySelector(
            "input[type='text'], textarea"
          ) as HTMLInputElement | HTMLTextAreaElement | null;
          if (
            !notesBox &&
            row.nextElementSibling &&
            !row.nextElementSibling.querySelector("input[type='checkbox']")
          ) {
            notesBox = row.nextElementSibling.querySelector(
              "input[type='text'], textarea"
            );
          }
          if (notesBox instanceof HTMLTextAreaElement) {
            // Tag so processTextAreas doesn't register it a second time
            notesBox.dataset.comprehendGrouped = 'true';
          }
          const notesSnapshot = notesBox ? notesBox.value : '';

          toReturn[soTitle].push({
            QuestionTextArray: [soTitle, questionText],
            Question: questionText,
            Choices: options,
            Type: 'Choose All',
            Input: (value, replyType) => {
              checkboxes.forEach((box) => {
                let boxLabel = box.nextElementSibling?.textContent.trim();
                if (boxLabel) {
                  let shouldBeChecked = value.includes(boxLabel);
                  if (shouldBeChecked !== box.checked) {
                    box.click(); // Click only if state differs
                  }
                } else {
                  console.warn('No label found for checkbox:', box);
                }
              });
              // Write only the leftover narrative (answer minus labels) — never the raw
              // value. Skipped once the "- Notes" subfield has written this fill.
              if (
                notesBox &&
                !isEmptyOrNull(value) &&
                notesBox.value === notesSnapshot
              ) {
                let narrative = Array.isArray(value)
                  ? value.join('; ')
                  : String(value);
                for (const lbl of options) {
                  narrative = narrative.split(lbl).join('');
                }
                narrative = narrative.replace(/^[\s;.,]+/, '').trim();
                if (narrative) {
                  notesBox.value =
                    replyType === 'append' && notesBox.value
                      ? (notesBox.value + '\n' + narrative).trim()
                      : narrative;
                }
              }
            }
          });

          // "- Notes" subfields give the narrative an explicit home; a labels-only
          // Choose-All answer leaves the leftover-narrative write above with nothing
          let freeTextInputs = Array.from(
            row.querySelectorAll("input[type='text']")
          ) as (HTMLInputElement | HTMLTextAreaElement)[];
          if (notesBox instanceof HTMLTextAreaElement) {
            freeTextInputs.push(notesBox);
          }
          freeTextInputs.forEach((freeTextInput, freeTextIdx) => {
            let inputEl = freeTextInput;
            let existingNote = inputEl.value ? inputEl.value.trim() : '';
            let notesLabel =
              freeTextInputs.length > 1
                ? `${questionText} - Notes ${freeTextIdx + 1}`
                : `${questionText} - Notes`;
            toReturn[soTitle].push({
              QuestionTextArray: [soTitle, notesLabel],
              Question: notesLabel,
              Choices: [],
              ExistingNote: existingNote,
              Input: (val, replyType) => {
                if (isEmptyOrNull(val)) {
                  return;
                }
                if (replyType === 'append') {
                  inputEl.value = (inputEl.value + '\n' + val).trim();
                } else {
                  inputEl.value = val;
                }
              }
            });
          });

          continue;
        }
      }
    } else {
      var options = getMCChoices(optionSelector);

      // Chose a const here so we make a new one every time we iterate over the for loop
      let inputs = row.querySelectorAll('input, textarea'); // Select all input and textarea elements
      if (tableTitle === null) {
        console.error('No table title found, skipping this table');
        return {};
      }

      inputs.forEach((input, index) => {
        let inputType =
          input.tagName.toLowerCase() === 'textarea'
            ? 'Long Answer'
            : 'Short Answer';
        let existingNote = input.value ? input.value.trim() : '';
        if (inputType === 'Short Answer' && input.type !== 'text') {
          console.error('Skipping input with type:', input.type);
          return;
        }
        if (inputType === 'Long Answer') {
          // Flex-column textarea (e.g. Goals at box height > 1); tag so processTextAreas skips it
          (input as HTMLElement).dataset.comprehendGrouped = 'true';
        }
        let columnLabel = columnHeaders[index] || questionText; // Default fallback if no header exists
        let questionTextArray = [];
        questionTextArray.push(questionText, columnLabel);
        let labeledQuestionText = questionTextArray.join(' - '); // Use column header instead of numeric index
        toReturn[tableTitle].push({
          QuestionTextArray: questionTextArray,
          Question: labeledQuestionText,
          Choices: options,
          Type: inputType,
          ExistingNote: existingNote,
          Input: (val, replyType) => {
            if (isEmptyOrNull(val)) {
              return;
            }
            if (replyType === 'append') {
              input.value = (input.value + '\n' + val).trim();
            } else {
              input.value = val;
            }
          }
        });
      });
    }
  }

  // Disabled: each accumulated SOAP text subfield becomes its own top-level section
  for (const subTitle of Object.keys(flatSections)) {
    const textareas = flatSections[subTitle];
    if (textareas.length === 0) continue;
    const tas = textareas;
    const existingNote = tas[0].value.trim();
    (toReturn as any)[subTitle] = (toReturn as any)[subTitle] || [];
    (toReturn as any)[subTitle].push({
      QuestionTextArray: [subTitle, subTitle],
      Question: subTitle,
      Choices: [],
      ExistingNote: existingNote,
      Input: (val: any, replyType: any) => {
        if (!val || val === '' || val === 'None') return;
        tas.forEach((ta) => {
          ta.value =
            replyType === 'append' ? (ta.value + '\n' + val).trim() : val;
        });
      }
    });
  }

  return toReturn;
}

/* 
questions - This is where we will store the questions
          - a list of dictionaries
     [{
        "Question": "Where was the injury?", 
        "Type": "Multiple Choice", 
        "Choices": ["Back", "Neck", "Shoulder"]
     },
        ...
        ]
 
*/
var questions = [];

/*
question Interactions - This is where we will store the interactions for each question
                        - a dictionary of dictionaries
         {
            "Where was the injury?": {
                "Type": "Multiple Choice",
                "Choices"{
                    "Back": () => {click the back button},
                    "Neck": () => {click the neck button},
                    "Shoulder": () => {click the shoulder button}
                }
            },
        },
        {
            "What is the injury?": {
                "Type": "Long Answer",
                "Input": (val) => {input the value into the input box}
        }
            ...
         }
*/
var questionInteractions = {};

var header = '';

// function getQuestions() {
export function getQuestions(
  isWebPTUser = false,
  dropdownCache = {},
  replyType = {},
  empowerNewVersion = false
) {
  /*
     Description: This function will get the questions from the note
     Return: A list of dictionaries with the questions
         [{
             "Question": "Where was the injury?", 
             "Type": "Multiple Choice", 
             "Choices": ["Back", "Neck", "Shoulder"]
         },...
         }
     */
  // Remember the caller's setting so a capture poll emits the same key shape.
  rememberEmpowerNewVersion(empowerNewVersion);

  // Clear the questions
  questions = [];

  // Fetch the most recent note(s)
  let notes = getNote(); // Ensure this returns an array if multiple notes exist
  if (!notes || (Array.isArray(notes) && notes.length === 0)) {
    console.log('No notes found.');
    // If no TABLES are found, there is still always going to be the last text area
    var questionInteractionsLocal = {};
    const qs = processTextAreas(questionInteractionsLocal, true); // Process text areas even if no notes found
    processQuestions(questionInteractionsLocal);
    return questions; // Return empty array
  }

  // Ensure notes is always an array
  if (!Array.isArray(notes)) {
    notes = [notes];
  }

  for (const note of notes) {
    let qs = scrapeQuestions(note, empowerNewVersion);

    if (!qs || Object.keys(qs).length === 0) {
      console.warn('No questions found in note:', note);
      continue; // Skip this note if no questions are found
    }

    processQuestions(qs);
  }

  sortQuestionsByDocumentPosition();
  console.log('Final Questions List:', questions);

  return questions;
}

/*
Note Capture.

NoteCapture.ts polls getQuestionsForCapture on a timer and NoteStore merges each
snapshot into the stored note by top-level key. Empower renders one note section
at a time, so each poll returns whichever section is on screen and the full note
accumulates as the clinician moves through them — no section is ever opened or
clicked to collect it. Top-level sections come from the note template and cannot
be added or removed, so a key missing from a snapshot only ever means "not
rendered right now", never "deleted".
*/
let captureScrapeActive = false;

// Only composenote.html holds the editable note. finishNote.html carries the
// same nid but renders a read-only preview, which must never be scraped over
// the real note.
const NOTE_EDITOR_PATH_PATTERN = /\/notepad\/composenote\.html$/i;

/*
empowerNewVersion decides the shape of the scraped keys: flat "SOAP - Subjective"
sections when disabled (the default), one nested "SOAP" Flex question when
enabled. It is a per-user setting the panel passes into getQuestions, and a
capture poll has no way to read it — so latch whatever the panel last sent and
reuse it, keeping captured keys aligned with the keys the panel writes.

Kept in localStorage rather than memory because every Empower section switch is
a full postback, which would wipe an in-memory latch before the next poll.
localStorage and not chrome.storage: injectors also run in the embed, iPad and
iPhone builds, which have no extension APIs. Until the panel has scraped once
the latch is unset and capture uses the default, so a note captured before then
can hold both key shapes.
*/
const EMPOWER_NEW_VERSION_KEY = 'comprehendpt_empower_new_version';

/*
How the last snapshot arranged the note: empowerNewVersion nests SOAP under a
single section, and without it the same five fields become five top-level ones.
NoteStore replaces the stored note when this changes, so polls taken before the
setting was known cannot leave a second, frozen copy of those sections behind.

Recorded by the scrape rather than read again here, so it always describes the
snapshot it is handed alongside.
*/
let lastCaptureShape: string | null = null;

export function getQuestionShapeForCapture() {
  return lastCaptureShape;
}

function rememberEmpowerNewVersion(empowerNewVersion) {
  // Only the panel's value is authoritative; a capture poll just passes back
  // whatever it read a moment ago.
  if (captureScrapeActive || typeof empowerNewVersion !== 'boolean') return;
  try {
    localStorage.setItem(EMPOWER_NEW_VERSION_KEY, String(empowerNewVersion));
  } catch (_) {
    // Never let a failed latch write break the scrape that triggered it.
  }
}

function loadEmpowerNewVersion() {
  try {
    return localStorage.getItem(EMPOWER_NEW_VERSION_KEY) === 'true';
  } catch (_) {
    return false;
  }
}

/**
 * Return a stable key for the open note. Each EMR may derive this differently,
 * but the same note must always return the same key and two notes must not
 * share one. Empower carries a note GUID in the query string on both the editor
 * (/Notepad/composenote.html?nid=...) and the finalize page
 * (/NoteViewer/finishNote.html?secid=...&fc=true&nid=...).
 *
 * Deliberately not gated on the path: finalizeCurrentNote reads this on the
 * finalize page to mark sign-off against the note the editor stored, so both
 * pages must resolve to the same key.
 */
export function getNoteKeyForCapture() {
  const nid = new URLSearchParams(window.location.search).get('nid');
  if (!nid || !/^[0-9a-f-]{16,}$/i.test(nid)) return null;
  return `note:${nid.toLowerCase()}`;
}

export function getPageInfoForCapture() {
  try {
    return getPageInfo();
  } catch (_) {
    return null;
  }
}

export function getPatientInfoForCapture() {
  try {
    const patientInfo = getPatientInfo();
    // The header inputs are absent outside the note editor, where getPatientInfo
    // reports every field as ''. Storing an unidentified patient is worse than
    // storing nothing.
    if (!patientInfo['EMR ID'] && !patientInfo['Last Name']) return null;
    return patientInfo;
  } catch (_) {
    return null;
  }
}

/**
 * Return current note values keyed by question key. Long answers are strings;
 * Flex values preserve their nested section and field keys.
 *
 * { [questionKey]: string | { [fieldKey]: string | nested values } }
 *
 * Returns {} away from the note editor, which the poller treats as nothing to
 * save.
 */
export function getQuestionsForCapture(): Record<string, any> {
  if (!NOTE_EDITOR_PATH_PATTERN.test(window.location.pathname)) return {};

  /*
  getQuestions rebuilds the module-level questions and adds to
  questionInteractions, and answerQuestion resolves its Input closures out of the
  latter — including on its isLocked retry path, after a sleep. Restore both so a
  capture poll can never disturb an in-flight Comprehend. This whole function is
  synchronous, so nothing else can run between the save and the restore.

  questions is safe to hold by reference because getQuestions replaces it.
  questionInteractions is only ever mutated, so it needs a copy.
  */
  const empowerNewVersion = loadEmpowerNewVersion();
  lastCaptureShape = empowerNewVersion ? 'empower-grouped' : 'empower-flat';

  const savedQuestions = questions;
  const savedInteractions = { ...questionInteractions };
  captureScrapeActive = true;
  try {
    return extractCaptureValues(
      getQuestions(false, {}, {}, empowerNewVersion)
    );
  } finally {
    captureScrapeActive = false;
    questions = savedQuestions;
    questionInteractions = savedInteractions;
  }
}

function extractCaptureValues(capturedQuestions) {
  const values = {};

  capturedQuestions.forEach((question, index) => {
    const key = question?.Key || question?.Question || String(index);
    const value = getCaptureValue(question);
    if (value !== null && value !== undefined) {
      values[key] = value;
    }
  });

  return values;
}

/*
Empower rewrites the note after our write lands: "120/70" becomes "120 / 70",
"2x/week" becomes "2x / week". A clinician can neither produce nor prevent that,
so it is EMR formatting rather than an edit — and left in, it inflated the
backend's edit distance by 41% on the first note we captured. Both the stored
note and the AI baseline are built from this path, so normalising here keeps the
two comparable and keeps the quirk out of NoteStore and the backend.

Spaces and tabs only: collapsing a newline around a slash would change the
note's line structure.
*/
function normalizeCaptureText(value) {
  if (typeof value !== 'string') return value;
  return value.replace(/[ \t]*\/[ \t]*/g, '/');
}

function getCaptureValue(question) {
  // A Long Answer with an empty box reports ExistingNote null and carries no
  // Structure, so it drops out of the snapshot instead of being stored as ''.
  // Under NoteStore's merge that means clearing one is not recorded. Flex
  // subfields keep their '' and so do record a clear.
  if (question.ExistingNote !== null && question.ExistingNote !== undefined) {
    return normalizeCaptureText(question.ExistingNote);
  }
  if (question.Structure) {
    const values = extractFlexCaptureValues(question.Structure);
    return Object.keys(values).length > 0 ? values : null;
  }
  return null;
}

function extractFlexCaptureValues(structure) {
  const values = {};

  Object.entries(structure || {}).forEach(([key, value]) => {
    if (!value || typeof value !== 'object') return;

    if (Object.prototype.hasOwnProperty.call(value, 'Existing Value')) {
      values[key] = normalizeCaptureText(value['Existing Value'] ?? '');
      return;
    }

    const nested = extractFlexCaptureValues(value);
    if (Object.keys(nested).length > 0) {
      values[key] = nested;
    }
  });

  return values;
}

/*
Sign-off is two steps. "Ignore warnings and click here to finish note"
(#ctl00_cp1_notecomplete) only posts back to the preview at
/NoteViewer/finishNote.html; the note is signed by "Finalize Note" there, so
only the second button is watched.

Best-effort, not proof: its onclick is
`return confirm("There are unsigned notes for this patient/episode ...")`, so a
declined confirm still marks the note signed off here. That's tolerable because
sign-off never closes a note to further capture — the next poll corrects a
premature mark and the backend upserts.

Matched by name as well as id because ASP.NET derives the id from the control
hierarchy, so it moves if the page is restructured.
*/
export const noteFinalizationSelectorForCapture = '#ctl00_cp1_signitNow, input[name="ctl00$cp1$signitNow"]';

function processQuestions(qs) {
  // Iterate through the extracted questions
  for (const [tableName, value] of Object.entries(qs)) {
    if (!value) continue; // Skip invalid entries
    questionInteractions[tableName] = value;
    let questionObj = createQuestionObject(tableName, value);
    if (/^\s*[-–—]\s*\d+\s*$/.test(questionObj.Question)) {
      continue; // Skip questions that are just a number this is for Billing questions
    }
    if (shouldSkipQuestion(questionObj)) {
      console.log('Skipping Flex question with no structure:', questionObj);
      continue; // Skip Flex questions with no structure
    }

    if (!questionExists(questionObj)) {
      questions.push(questionObj);
    }
  }
}

function createQuestionObject(tableName, value) {
  return {
    Question: tableName,
    Key: value['Key'] || tableName, // Use tableName if 'Key' is missing
    Type: value['Type'] || 'Unknown', // Default to "Unknown" if missing
    Structure: value['Structure'] || {}, // Retain full structure
    originalElement: value['originalElement'] || null,
    ExistingNote: value['ExistingNote'] || null
  };
}

function shouldSkipQuestion(questionObj) {
  return (
    questionObj.Type === 'Flex' &&
    Object.keys(questionObj.Structure).length === 0
  );
}

function questionExists(questionObj) {
  return questions.some(
    (q) => q.Question === questionObj.Question && q.Key === questionObj.Key
  );
}

function sortQuestionsByDocumentPosition() {
  questions.sort((a, b) => {
    let elA = a.originalElement;
    let elB = b.originalElement;

    if (!elA || !elB) return 0; // Skip sorting if elements are missing

    return elA.compareDocumentPosition(elB) & Node.DOCUMENT_POSITION_FOLLOWING
      ? -1
      : 1;
  });
}

function detectPattern(choices) {
  if (!Array.isArray(choices) || choices.length === 0) return null;

  // Function to extract numbers from a string
  function extractNumbers(str) {
    return str.match(/\d+/g)?.map(Number) || [];
  }

  // Function to replace numbers with placeholders
  function replaceNumbersWithX(str) {
    return str.replace(/\d+/g, 'X');
  }

  // Collect transformed versions of choices
  let transformedChoices = new Set(choices.map(replaceNumbersWithX));

  // If all choices follow one pattern, return its neutralized version
  if (transformedChoices.size === 1) {
    return transformedChoices.values().next().value.replace(/X/g, '0');
  }

  // Identify the most common numerical sequence pattern
  let numPatterns = choices.map(extractNumbers).filter((arr) => arr.length > 0);

  if (numPatterns.length > 0) {
    let firstPattern = replaceNumbersWithX(
      choices.find((choice) => extractNumbers(choice).length > 0)
    );
    return firstPattern.replace(/X/g, '0');
  }

  return null; // No recognizable pattern found
}

var isLocked = false;

export async function answerQuestions(answers) {
  // function answerQuestions(answers) {
  /*
    Description: This function will take the answers and populate the questions
    
    Args: 
        answers: A dictionary of answers
            "Question": "The question in question"
            "Answer": "The answer to the question"
   
    Return: A list of any questions that were not answered, perhaps the answer didn't match the questions expected or whatnot...
        [
            {
                Question: "Where was the injury?", 
                Answer: "Back" 
                Error: "The error message" (Choice not found, etc)
            },
            ...
        }

    */
  var errors = [];
  const answerPromises = answers.map(async (answer) => {
    var error = await answerQuestion(answer['Question'], answer['Answer']);
    if (error) {
      errors.push({
        Question: answer['Question'],
        Answer: answer['Answer'],
        Error: error
      });
    }
  });

  await Promise.all(answerPromises); // Wait for all answers to process

  console.error('Errors:', errors);
  return errors;
}

var isLocked = false;
export async function answerQuestion(
  question,
  answer,
  replyType,
  totalWaitTime = 0
) {
  if (!questionInteractions[question]) {
    console.error(`Question not found: "${question}"`);
    return 'Question not found';
  }
  // function answerQuestion(question, answer) {
  /*
      Description: This function will take the answer and populate the question
      
      Args: 
          question: The question in question
          answer: The answer to the question
     
      Return: null if success otherwise a string with the error message
      */

  // console.log("Answering Question: '" + question + "' with '" + answer+"'")

  // If it's a flex do so
  if (questionInteractions[question]['Type'] === 'Flex') {
    return await answerFlexQuestion(question, answer, replyType);
  }
  // Make sure the question exists
  if (questionInteractions[question] == null) {
    console.error('Question not found');
    console.error(question);
    // console.log(questionInteractions)
    // console.log(Object.keys(questionInteractions))

    return 'Question not found';
  }

  // if we are locked, delay for a random amount of time between .1 and 1 seconds waiting no longer than 3 seconds
  if (isLocked && totalWaitTime < 3000) {
    let delay = Math.random() * 1000;
    return sleep(delay).then(() => {
      return answerQuestion(question, answer, replyType, totalWaitTime + delay);
    });
  }

  // Se our lock
  isLocked = true;

  try {
    // If it is a short answer or long answer, just populate the input
    if (questionInteractions[question]['Input']) {
      await questionInteractions[question]['Input'](answer, replyType);
      isLocked = false;
      return true;
    }

    // Check if the answer is a list of answers or just a single answer
    if (Array.isArray(answer)) {
      // Choose All
      var notFoundAnswers = [];
      for (var i = 0; i < answer.length; i++) {
        if (answer[i] in questionInteractions[question]['Choices']) {
          console.log('Answer found ' + answer[i]);
          await questionInteractions[question]['Choices'][answer[i]](true);
          // sleep(1000).then(() => {
          //     questionInteractions[question][answer[i]]()
          // });
        } else {
          notFoundAnswers.push(answer[i]);
        }
      }
      if (notFoundAnswers.length > 0) {
        console.error(
          'The following answers were not found: ' + notFoundAnswers
        );
        return 'The following answers were not found: ' + notFoundAnswers;
      } else {
        return true;
      }
    } else {
      // Multiple Choice
      if (answer in questionInteractions[question]['Choices']) {
        await questionInteractions[question]['Choices'][answer]();
        return true;
      } else {
        console.error('Answer not found');
        console.log('Question: ' + question);
        console.log('Answer:' + answer);
        console.log(questionInteractions[question]['Choices']);
        return 'Answer not found';
      }
    }
  } finally {
    isLocked = false;
  }
}

async function answerFlexQuestion(
  question,
  answer,
  replyType = 'overwrite',
  totalWaitTime = 0
) {
  try {
    // If we are locked, delay for a random amount of time between 0.1 and 1 seconds, waiting no longer than 3 seconds
    if (isLocked && totalWaitTime < 3000) {
      let delay = Math.random() * 1000;
      return sleep(delay).then(() => {
        return answerFlexQuestion(
          question,
          answer,
          replyType,
          totalWaitTime + delay
        );
      });
    }

    // Set the lock
    isLocked = true;

    const errors = [];
    const questionObject = questionInteractions[question];

    if (!questionObject) {
      console.error(`Question with Key "${question}" not found.`);
      return {
        Question: question,
        Error: `Question with Key "${question}" not found.`
      };
    }

    const structure = questionObject.Structure || {};

    /** Do the answering sequentially */
    for (const [fieldKey, fieldDetails] of Object.entries(answer)) {
      // AI may respond using a sub-field name as the top-level key; search one level deep for a match
      const field =
        structure[fieldKey] ??
        Object.values(structure).find((s: any) => s[fieldKey]);

      if (!field) {
        console.error(`Field "${fieldKey}" not found in the Structure.`);
        errors.push({ Field: fieldKey, Error: 'Field not found in Structure' });
        continue;
      }

      for (const [subFieldKey, value] of Object.entries(
        fieldDetails as Record<string, unknown>
      )) {
        if (field[subFieldKey]?.Input) {
          try {
            await field[subFieldKey].Input(value, replyType);
          } catch (error) {
            errors.push({
              Field: `${fieldKey}.${subFieldKey}`,
              Error: `Error applying value: ${error.message}`
            });
          }
        } else {
          console.warn(
            `Input function not found for "${fieldKey}.${subFieldKey}"`
          );
          errors.push({
            Field: `${fieldKey}.${subFieldKey}`,
            Error: 'Input function not found'
          });
        }
      }
    }

    /** Parse the errors */
    if (errors.length > 0) {
      console.error('Errors occurred:', errors);
      return errors;
    }

    return null; // Success
  } catch (error) {
    console.error('Unexpected error:', error);
    return {
      Question: question,
      Error: `Unexpected error: ${error.message}`
    };
  } finally {
    // Release the lock
    isLocked = false;
  }
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
// function prettyPrintQuestions() {
//     console.log("Starting Pretty Print\n\n\n")
//     let qs = getQuestions()
//     for (var i = 0; i < qs.length; i++) {
//         console.log("________________________")
//         console.log(qs[i]["Key"])
//         // console.log(qs[i]["Question"] + " - " + qs[i]["Type"])
//         console.log("________________________")
//     }
// }

// prettyPrintQuestions()

function getExistingNote(value) {
  if (typeof value !== 'string') {
    return null;
  }

  let val = value?.trim();
  return val === '' ? null : val;
}

function isEmptyOrNull(value) {
  return (
    value === null || value === undefined || value === '' || value === 'None'
  );
}

export async function getLogFromInjector() {
  // Scrape errors are reported by shipping the whole page. Capture polls in the
  // background, so a recurring error would upload the page every few seconds.
  if (captureScrapeActive) return null;

  try {
    const htmlContent = document.documentElement.outerHTML;
    chrome.runtime.sendMessage({
      type: 'INJECTOR_ERROR',
      error: { htmlContent: htmlContent }
    });
    return { htmlContent: htmlContent };
  } catch (error) {
    // Return the full HTML content of the document
    console.error('Error occurred while fetching document:', error);
    getLogFromInjector();
  }
}
